import React from 'react';
import { connect } from 'react-redux';
import { Icon, Menu, SemanticICONS, Tab } from 'semantic-ui-react';
import { EUserGroup, EUserLevels, IProject, IUser, ProjectUtils } from '@relab/alstom-ptw-shared';

import { appState } from '../../redux/selectors';
import { PtwsComponent } from '../ptw/PtwsComponent';
import { TrainsComponent } from '../train/TrainsComponent';
import { AssigneeComponent } from '../AssigneeComponent';
import { RootState } from '../../redux/types';

const MenuItem = ({ key, icon, ...otherProps }: { key: string; icon: SemanticICONS }) => (
  <Menu.Item key={key} {...otherProps}>
    <Icon name={icon} size="large" />
  </Menu.Item>
);

interface ProjectDetailComponentProps {
  project: IProject;
  user: IUser;
}

const _ProjectDetailComponent = ({ project, user }: ProjectDetailComponentProps) => {
  const userHasPermissions = ProjectUtils.checkUserPermissionsOnProject(project, user, [
    EUserGroup.PRTCM,
    EUserGroup.PQM,
  ]);

  const restrictedPanes =
    userHasPermissions || user.userLevel === EUserLevels.Admin
      ? [
          {
            menuItem: <MenuItem key="people" icon="users" />,
            render: () => (
              <Tab.Pane>
                <AssigneeComponent />
              </Tab.Pane>
            ),
          },
          {
            menuItem: <MenuItem key="trains" icon="train" />,
            render: () => (
              <Tab.Pane>
                <TrainsComponent />
              </Tab.Pane>
            ),
          },
        ]
      : [];

  return (
    <Tab
      grid={{ paneWidth: 14, tabWidth: 2 }}
      menu={{ fluid: true, vertical: true, tabular: true, size: 'huge', icon: true }}
      panes={[
        {
          menuItem: <MenuItem key="dashboard" icon="th list" />,
          render: () => (
            <Tab.Pane>
              <PtwsComponent projectId={project._id} />
            </Tab.Pane>
          ),
        },
        ...restrictedPanes,
      ]}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  user: appState(state).user,
});

export const ProjectDetailComponent = connect(mapStateToProps)(_ProjectDetailComponent);
